export default "__VITE_ASSET__CmPK1oAa__"